import { useContext } from 'react';
import SmartSendBackgroundTasks from '~/apps/smartsend/components/smartsend/background/SmartSendBackgroundTasks';
import SupportBackgroundTasks from '~/apps/smartsend/components/smartsend/background/SupportBackgroundTasks';
import { SmartSendItemStateObserver } from '~/apps/smartsend/components/smartsend/SmartSendItemStateObserver';
import { SmartSendContext } from '~/apps/smartsend/lib/context/SmartSendContext';

export const SmartSendTasks = () => {
  const { state } = useContext(SmartSendContext);
  return (
    <>
      <SupportBackgroundTasks />
      {state.customerInitialised && (
        <>
          <SmartSendItemStateObserver />
          <SmartSendBackgroundTasks />
        </>
      )}
    </>
  );
};
